
import React from 'react';
import { Input } from '@/components/ui/input';

interface CalculatorDisplayProps {
  value: string;
}

const CalculatorDisplay: React.FC<CalculatorDisplayProps> = ({ value }) => {
  return (
    <div className="bg-green-900 p-2 mb-3 rounded-md border-0">
      <Input
        className="text-right text-xl font-mono bg-green-200 text-green-900 h-12 font-bold border-0 rounded focus:ring-2 focus:ring-offset-1 focus:ring-green-700 focus:outline-none"
        value={value}
        readOnly
        tabIndex={0}
      />
    </div>
  );
};

export default CalculatorDisplay;
